import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/home',
    component:()=>import('./view/home'),
    meta: {
      title: '个人中心'
    }
  },

  {
    path: '/searchFiles',
    component:()=>import('./view/customFiles/search'),
    meta: {
      title: '证件检索'
    }
  },

  {
    path: '/askList',
    component:()=>import('./view/askList/index'),
    meta: {
      title: '答疑解惑'
    }
  },

  {
    path: '/askDetail',
    component:()=>import('./view/askDetail/index'),
    meta: {
      title: '互动问答'
    }
  },

  {
    path: '/askAdd',
    component:()=>import('./view/askAdd/index'),
    meta: {
      title: '我有疑惑'
    }
  },
  
  {
    path: '/exercise',
    component:()=>import('./view/exercise'),
    meta: {
      title: '模拟练习'
    }
  },
  {
    path: '/exercise2',
    component:()=>import('./view/exercise/index2'),
    meta: {
      title: '模拟练习'
    }
  },
  {
    path: '/rank',
    component:()=>import('./view/exercise/rank'),
    meta: {
      title: '模拟考试排名'
    }
  },
  {
    path: '/bindCard',
    component:()=>import('./view/bindCard'),
    meta: {
      title: '实名绑定'
    }
  },

  {
    path: '/courseList',
    component:()=>import('./view/courseList'),
    meta: {
      title: '在线培训'
    }
  },

  
  {
    path: '/trainlist',
    component:()=>import('./view/trainlist'),
    meta: {
      title: '我的培训'
    }
  },

  {
    path: '/filelist',
    component:()=>import('./view/customFiles'),
    meta: {
      title: '我的证件'
    }
  },

  {
    path: '/certificateDelegate',
    component:()=>import('./view/certificateDelegate'),
    meta: {
      title: '委托领证'
    }
  },

  {
    path: '/examlist',
    component:()=>import('./view/examlist'),
    meta: {
      title: '我的考试'
    }
  },
  {
    path: '/compareFace',
    component:()=>import('./view/compareFace'),
    meta: {
      title: '人脸识别'
    }
  },

  {
    path: '/examOnline',
    component:()=>import('./view/examonline'),
    meta: {
      title: '手机考试'
    }
  },

  {
    path: '/upload',
    component:()=>import('./view/upload'),
    meta: {
      title: '我要上传'
    }
  },

  {
    path: '/signupList',
    component:()=>import('./view/signupList'),
    meta: {
      title: '报考列表'
    }
  },

  {
    path: '/signupType',
    component:()=>import('./view/signupType'),
    meta: {
      title: '报考列表'
    }
  },
  {
    path: '/signUp',
    component:()=>import('./view/signUp'),
    meta: {
      title: '在线报名'
    }
  },

    

  {
    path: '/signUpCy',
    component:()=>import('./view/signUp/index2'),
    meta: {
      title: '从业在线报名'
    }
  },

  {
    path: '/courseDetail',
    component:()=>import('./view/courseDetail'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/courseDetailHarmous',
    component:()=>import('./view/courseDetail/harmous'),
    meta: {
      title: '鸿蒙详情'
    }
  },

  {
    path: '/login',
    component:()=>import('./view/login'),
    meta: {
      title: '授权登陆'
    }
  },

  {
    path: '/memberInfo',
    component:()=>import('./view/orginfo'),
    meta: {
      title: '会员单位'
    }
  },

  
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode:'history',routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
